import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';

type ExitIconProps = Omit<BaseIconProps, 'children'>;

export const ExitIcon = ({ strokeWidth, hasLegacyStrokeStyles, ...props }: ExitIconProps) => (
  <BaseIcon
    hasLegacyStrokeStyles={hasLegacyStrokeStyles ?? true}
    width="24"
    height="24"
    viewBox="0 0 16 16"
    fill="none"
    strokeWidth={strokeWidth}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33333 3C3.24493 3 3.16014 3.03512 3.09763 3.09763C3.03512 3.16014 3 3.24493 3 3.33333V12.6667C3 12.7551 3.03512 12.8399 3.09763 12.9024C3.16014 12.9649 3.24493 13 3.33333 13H6C6.55228 13 7 13.4477 7 14C7 14.5523 6.55228 15 6 15H3.33333C2.71449 15 2.121 14.7542 1.68342 14.3166C1.24583 13.879 1 13.2855 1 12.6667V3.33333C1 2.7145 1.24583 2.121 1.68342 1.68342C2.121 1.24583 2.7145 1 3.33333 1H6C6.55228 1 7 1.44772 7 2C7 2.55228 6.55228 3 6 3H3.33333Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.95956 3.95952C10.3501 3.56899 10.9832 3.56899 11.3738 3.95952L14.7071 7.29285C15.0976 7.68338 15.0976 8.31654 14.7071 8.70707L11.3738 12.0404C10.9832 12.4309 10.3501 12.4309 9.95956 12.0404C9.56904 11.6499 9.56904 11.0167 9.95956 10.6262L12.5858 7.99996L9.95956 5.37373C9.56904 4.98321 9.56904 4.35004 9.95956 3.95952Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 7.99996C5 7.44767 5.44772 6.99996 6 6.99996H14C14.5523 6.99996 15 7.44767 15 7.99996C15 8.55224 14.5523 8.99996 14 8.99996H6C5.44772 8.99996 5 8.55224 5 7.99996Z"
    />
  </BaseIcon>
);

ExitIcon.displayName = 'ExitIcon';
